import { render, staticRenderFns } from "./notifications-menu.vue?vue&type=template&id=195b9d57"
import script from "./notifications-menu.vue?vue&type=script&lang=js"
export * from "./notifications-menu.vue?vue&type=script&lang=js"
import style0 from "./notifications-menu.vue?vue&type=style&index=0&id=195b9d57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports